import firebase from "firebase";
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAjo1tp2H9JDXGZZFBscW9v8eQmxSRuEVk",
    authDomain: "challenge-31446.firebaseapp.com",
    projectId: "challenge-31446",
    storageBucket: "challenge-31446.appspot.com",
    messagingSenderId: "203518345781",
    appId: "1:203518345781:web:744c4de5f3a094ee5ea77c",
    measurementId: "G-4F87850TP5"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();

export {db,auth};
